import { useEffect, useRef } from 'react';

import styles from './Scrollbox-alone.module.less';

/**
 * Container of a fixed size that expects content that will scroll vertically.
 * @param {string} contentHTML string representing HTML that will be rendered inside the Scrollbox area.
 * @param {string} contentID used to track whether or not the scrollbox should scroll back to the top of the render area.
 */

const Scrollbox = props => {
    const { contentHTML } = props;
    let contentboxRef = useRef(null);

    useEffect(() => {
        if (contentboxRef) {
            contentboxRef.scrollTop = 0;
        }
    }, [props.contentID]);

    return (
        <div
            ref={d => {
                contentboxRef = d;
            }}
            className={styles['scrollbox']}
            dangerouslySetInnerHTML={{ __html: contentHTML }}
        />
    );
};

export default Scrollbox;
